import { Component, Input, OnInit } from '@angular/core';
import { TranslationService } from '@dch/ng-common';
import { IBillingAccount, IBillingDocument } from '@dch/billing-business-logic';

@Component({
  selector: 'my-bill-faq',
  templateUrl: './my-bill-faq.component.html',
  standalone: false,
})
export class MyBillFaqComponent implements OnInit {
  @Input() billingAccount?: IBillingAccount;
  @Input() isResUser: boolean;
  @Input() billingDocument?: IBillingDocument;
  @Input() zone: string;
  @Input() hasSplitLine = true;

  faqTitle = '';

  constructor(private translationService: TranslationService) {}

  ngOnInit() {
    const resUserKey = this.isResUser ? 'RES.' : '';
    this.faqTitle = this.translationService.getTranslatedValueFor(
      `bills.redesign.settingsAndFaq.${resUserKey}faqTitle`
    );
  }

  onClickOfBillFaq() {
    const faqTranslationKey = this.isResUser ? 'faqResLink' : 'faqSeLink';
    const faqUrl = this.translationService.getTranslatedValueFor(
      `bills.redesign.settingsAndFaq.${faqTranslationKey}`
    );
    window.location.href = faqUrl;
  }
}
